/**
 * 互动邀请送礼逻辑 * 
 * https://docs.google.com/document/d/1CqECXV-zI-HHDjBTABCUxZWj-ozgpTuYxKMuO6yV6NU
 */

let { InteractiveInviteData } = require("./InteractiveInviteData")
let _config = null, _data = null;

let InteractiveInviteLogic = {
    /**
     * 启动
     * @param {boolean} forceFetchData 是否强制更新一遍互动数据
     */
    start(forceFetchData = false) {
        console.log("interactiveInvite", "InteractiveInviteLogic.start")
        return Promise.all([loadConfig(), requestInfo(forceFetchData)]);
    },

    /**
     * 今天是否点击过入口按键
     */
    hasOpenedToday() {
        return UserLocalSettings.getSetting("INTERACTIVE_INVITE_OPEN_TIME", 0) == Localhost.timeInDay();
    },

    /**
     * 打开主页面
     */
    openMain(onSuccess, onFail, onClose) {
        UserLocalSettings.setSetting("INTERACTIVE_INVITE_OPEN_TIME", Localhost.timeInDay());
        let InteractiveInvitePanel = require("./InteractiveInvitePanel");
        // 获取邀请信息
        Promise.all([requestInfo(true), InteractiveInvitePanel.preloadRes()])
        .then(()=> {
            let panel = InteractiveInvitePanel.create(_data, _config);
            panel.popup(true);
            
            // 监听定向分享结果
            if (window.mini){
                mini.onShareMessageToFriend(this.onShareMsgToFriend);
                panel.on(BasePanelEvent.Close, ()=>{
                    mini.onShareMessageToFriend(null);
                    onClose && onClose();
                });
                
            }
            onSuccess && onSuccess();
        })
        .catch(err=> {
            console.error("interactiveInvite", "open InteractiveInvitePanel failed", err)
            onFail && onFail(err);
        });
    },

    /**
     * 定向分享结果监听
     */
    onShareMsgToFriend(res) {
        console.log("interactiveInvite", "onShareMessageToFriend", res);
        if (res.success) {
            NewUserTaskManager.getInstance().tryCompleteTask(NewUserTaskManager.TASK_TYPE_ENUM.gifts)
            OpenContextUtil.postMessage({
                command: "interactive share success"
            });
            console.log("interactiveInvite", "requst addProgressReward start");
            DCAssist.dc4SMFShareSent("smf_interactive_friendcloud",  { num: _data.progress })
            // 旧分享打点兼容，用于处理点击分享+分享成功打点
            // 迭代完成后可删除
            if (OLD_SHAREDC_AVAILABLE) {
                DCAssist.dc4ClickShare("interactive", "card_send_success", { num: _data.progress }, { channel_index: 0 });
            }
            
            let http = InteractiveProgressPlusHttp.new()
            http.addEventListener(Events.kComplete, evt=> {
                console.log("interactiveInvite", "addProgressReward success", evt);
                _data && _data.progressAdd();
            });           
            http.load();
        }
    },

    /**
     * 领取互动奖励
     */
    getInteractiveGift() {
        return new Promise((resolve, reject)=> {
            mini.getUserInteractiveStorage({
                keyList: ['1', '2', '3', '4'],
                success: res=> {
                    console.log("interactiveInvite", "getUserInteractiveStorage success", res);
                    if (!res.encryptedData || !res.iv) {
                        reject({data: 0});
                        return;
                    }
                    let http = FetchInteractiveRewardHttp.new();
                    http.addEventListener(Events.kComplete, (evt)=> {
                        console.log("interactiveInvite", "FetchInteractiveRewardHttp success", evt);
                        // 更新数据
                        _data && _data.updateInterctiveRewardRsp(evt.data);
                        // 添加奖励数据
                        if (evt.data.reward) {
                            var map = {}
                            for (let i = 1, v = evt.data.reward[1]; v; i++ , v = evt.data.reward[i]) {
                                UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.INTERACTIVE_INVITE, {
                                    category: "share",
                                    sub_category: "interactive_invite" 
                                });
                                if (!map[v.itemId]) {
                                    map[v.itemId] = v.num
                                } else {
                                    map[v.itemId] = v.num + map[v.itemId];
                                }
                            }
                            var rewards = table();
                            for(var key in map) {
                                table.insert(rewards, {itemId: key, num: map[key]});
                            }
                            resolve(rewards);

                            let rewardNum = evt.data.rewardNum;
                            DCAssist.userTrack("interactive", "get_interactive_reward", { reward: rewardNum[1], rewards: rewardNum[2]});   // 用用户点击领奖按钮后、并成功领取到互赠奖励时
                        } else {
                            resolve(null);
                        }
                    });

                    http.addEventListener(Events.kError, reject);
                    http.addEventListener(Events.kCancel, reject);
                    http.load({
                        encryptedData: res.encryptedData,
                        iv: res.iv
                    });
                },
                fail: err=> {
                    console.error("interactiveInvite", "getUserInteractiveStorage fail", err)
                    reject({data: 0});
                }
            }); 
        });
    },

    /**
     * 领取进度奖励
     */
    getProgressReward() {
        return new Promise((resolve, reject)=> {
            let http = FetchInteractiveProgressGetHttp.new();
            http.addEventListener(Events.kComplete, (evt)=> {
                console.log("interactiveInvite", "FetchInteractiveProgressGetHttp success", evt);
                // 更新数据
                _data && _data.updateProgressRewardRsp(evt.data);
                // 添加奖励数据
                if (evt.data.reward) {
                    var map = {}
                    for (let i = 1, v = evt.data.reward[1]; v; i++ , v = evt.data.reward[i]) {
                        UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.INTERACTIVE_PROGRESS, {
                            category: "share",
                            sub_category: "smf_interactive_friendcloud" 
                        });
                        if (!map[v.itemId]) {
                            map[v.itemId] = v.num
                        } else {
                            map[v.itemId] = v.num + map[v.itemId];
                        }
                    }
                    var rewards = table();
                    for(var key in map) {
                        table.insert(rewards, {itemId: key, num: map[key]});
                    }
                    resolve(rewards);
                    DCAssist.userTrack("interactive", "get_extra_reward", { num: _data.count });   // 领取累计奖励礼盒打点
                } else {
                    resolve(null);
                }
            });

            http.addEventListener(Events.kError, reject);
            http.addEventListener(Events.kCancel, reject);
            http.load();
        });
    }
}

/**
 * 加载配置
 */
function loadConfig() {
    if (_config)
        return Promise.resolve(_config);

    return CfgManager.load("game", "interactive_invite")
    .then((dataMap)=> {
        console.log("interactiveInvite", "load origin config success", dataMap)
        let interactiveConfig = dataMap.get("interactive_invite");
        let gameConfig = dataMap.get("game");
        _config = parseConfig(interactiveConfig, gameConfig); 
        CfgManager.release("game", "interactive_invite");
        console.log("interactiveInvite", "create config success", _config)
        return Promise.resolve(_config);
    });
}

/**
 * 获取邀请信息
 * @param {boolean} forceFetchData 是否强制更新一遍互动数据
 * 
 */
function requestInfo(forceFetchData = false) {
    if (_data && !forceFetchData)
        return Promise.resolve(_data);

    return new Promise((resolve, reject)=> {
        let doRequest = function(){
            console.log("[interactive] getUserInteractiveStorage start")
            if (!window.mini){
                _data = InteractiveInviteData.create({});
                resolve(_data);
                return
            }
            mini.getUserInteractiveStorage({
                keyList: ['1', '2', '3', '4'],
                success: res=> {
                    console.log("[interactive] getUserInteractiveStorage success", res);
                    if (!res.encryptedData || !res.iv) {
                        reject();
                        return;
                    }
                    let http = GetInteractiveInfoHttp.new()
                    http.addEventListener(Events.kComplete, evt=> {
                        console.log("[interactive] getFriendsHelpEachOtherReward success", evt);
                        if(!_data)
                            _data = InteractiveInviteData.create(evt.data);
                        else 
                            _data.update(evt.data);
                        resolve(_data);
                    });           
                    http.addEventListener(Events.kError, reject);
                    http.addEventListener(Events.kCancel, reject);
                    http.load({ encryptedData: res.encryptedData, iv: res.iv });
                },
                fail: ()=>{
                    console.log("[interactive] getUserInteractiveStorage fail");
                    _data = InteractiveInviteData.create({});
                    resolve(_data);
                }
            });   
        }
        
        // if (AuthorizeMgr.isAuthorizeByScope("FriendInteraction")){
        //     doRequest()
        // }else 
        if (mini && mini.supportGetUserInfo()) {
            console.log("[interactive] getSetting");
            mini.getSetting({
                success: function (res) {
                    console.log("[interactive] authsetting:" + JSON.stringify(res))
                    if (res.authSetting && res.authSetting["scope.WxFriendInteraction"]) {
                        doRequest()
                    }else{
                        reject();
                    }
                },
                fail: function () {
                    console.log("interactiveInvite authsetting: failed")
                    reject();
                }
            })
        }else{
            reject();
        } 
    });
}

function parseRewardConfig(data) {
    let str = data.split(':');
    return {
        id: str[0],
        num: parseInt(str[1])
    };
}

function parseConfig(interactiveConfig, gameConfig) {
    let config = {};
    config.list_limit = parseInt(interactiveConfig.interactive_list_limit); // 展示列表总上限
    config.potential_limit = parseInt(interactiveConfig.interactive_potential_count);   // 展示列表感兴趣好友上限
    config.exist_limit = parseInt(interactiveConfig.interactive_friendcloud_count); // 展示列表同玩好友上限
    config.list_priority = parseListPriority(interactiveConfig.interactive_friend_priority);   // 展示列表优先级
    config.progress_limit = parseInt(interactiveConfig.interactive_extrareward_progresslimit);   // 单条进度Max值
    config.potential_gift_limit = interactiveConfig.interactive_potential_limit;    // 感兴趣礼物可领取上限
    config.exist_gift_limit = interactiveConfig.interactive_friendcloud_limit;  // 同玩礼物可领取上限    
    config.extra_reward = parseExtraReward(interactiveConfig); // 进度奖励组 

    // 处理分享组
    let shareGroups = gameConfig["interactive_group"].split(",");
    let potentialShare = TextsManager.getInstance().getTextsListByType(shareGroups[0]);    
    let existShare = TextsManager.getInstance().getTextsListByType(shareGroups[1]);
    config.potential_share = parseShare(potentialShare); // 感兴趣好友分享组
    config.exist_share = parseShare(existShare); // 同玩好友分享组
    config.invite_share_group = shareGroups[2]; // 普通邀请分享组名
    
    return config;
}

/**
 * 解析列表展示优先级
 * 替换枚举参考 InteractiveConst文件中的值
 * @param {*} priorityStr 
 */
function parseListPriority(priorityStr) {
    let replaceMap = {
        "potential": "1",
        "friendcloud": "2",
        "inform": "1",
        "send": "0",
        "sent": "2",
    }
    priorityStr = priorityStr.replace(/[a-zA-Z]+/gi, (p)=> {
        return replaceMap.hasOwnProperty(p)? replaceMap[p]: p;
    });

    return priorityStr;
}

/**
 * 解析进度奖励
 * @param {*} interactiveConfig 
 */
function parseExtraReward(interactiveConfig) {
    let extra_reward = [];
    let strArray = interactiveConfig.interactive_extrareward_list.split(';'), str = null;
    for (var i = 0; i < strArray.length; i++) {
        str = strArray[i].substring(strArray[i].indexOf('{') + 1, strArray[i].indexOf('}')).split(',')
        let data = [];
        for (var j = 0; j < str.length; j++) {
            data.push(parseRewardConfig(str[j]));
        }
        extra_reward.push(data)
    }
    return extra_reward;
}

/**
 * 处理分享组
 * @param {*} ary 原始ary为luaTable
 */
function parseShare(ary) {
    let result = [], imageInfo = null;
    let snsProxy = require("clover/sns/SnsProxy").getInstance();
    let hasSafeLink = typeof snsProxy.decodeSafeLink === "function"

    for(let i = 0, len = ary.length, v = ary[i]; i < len; i++, v = ary[i]) {
        if (v) {
            imageInfo = hasSafeLink? snsProxy.decodeSafeLink(v.bg): null;
            result.push({
                title: v.content,
                imageUrl: imageInfo? imageInfo.imageUrl: v.bg,
                imageUrlId: imageInfo? imageInfo.imageUrlId: null
            });
        }
    }
    return result;
}

module.exports = InteractiveInviteLogic